import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/deffectiveReport.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-3e762e56")

_pushScopeId("data-v-3e762e56")
const _hoisted_1 = { class: "deffectiveReport" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "deffectiveReport_main" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "deffectImg",
    src: _imports_0,
    alt: "",
    srcset: ""
  }),
  /*#__PURE__*/_createVNode("p", { class: "tipTxt" }, "抱歉，当前报告已失效")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
})